import { useCallback, useState } from "react";
import { AuthCamera } from "@/domains/createCharacter/constants/authCamera";
import useChangeCamera from "@/domains/createCharacter/hooks/useChangeCamera";
import CreateCharacterCamera from "@/domains/createCharacter/components/CreateCharacterCamera";

export default function CreateCharacterCameraContainer() {
  const { changeCamera } = useChangeCamera();
  const variants = Object.values(AuthCamera);
  const [camera, setCamera] = useState(variants.at(-1) as string);
  const [isOpen, setIsOpen] = useState(false);

  const changeCameraHandler = useCallback(async (value: string) => {
    await changeCamera(value);
    setCamera(value);
  }, []);

  return (
    <CreateCharacterCamera
      variants={variants}
      value={camera}
      setValue={changeCameraHandler}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
}
